import amplitudeJs from "amplitude-js";
import { EventProperties, SendEvent } from "../types/amplitude";
import isBrowser from "../utils/next.util";
import { parseCookies } from "nookies";
const AMPLITUDE_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_KEY;

class Amplitude {
  private static instance: any;
  private static commonEvents: EventProperties | {};

  constructor() {
    if (!Amplitude.instance) {
      const amplitudeInstance = amplitudeJs.getInstance();

      Amplitude.instance = amplitudeInstance;
      Amplitude.instance.init(AMPLITUDE_KEY);
    }
  }

  setCommonEvents({ eventProperties }: { eventProperties: EventProperties }) {
    Amplitude.commonEvents = { ...eventProperties };
  }

  sendEvent({ type, properties, userId, userProperties }: SendEvent) {

    // Amplitude.instance.init(AMPLITUDE_KEY);
    const instanceUserId = userId || Amplitude.instance.getUserId();
    if (userId) {
      const identifyObj = new Amplitude.instance.Identify();
      identifyObj.set('user_id', instanceUserId);

      if (userProperties) {
        for (const key in userProperties) {
          if (Object.prototype.hasOwnProperty.call(userProperties, key)) {
            identifyObj.set(key, userProperties[key]);
          }
        }
      }
      Amplitude.instance.identify(identifyObj);
      Amplitude.instance.setUserId(instanceUserId);
    } else if (userProperties) {
      Amplitude.instance.setUserProperties(userProperties);
    }
    const cookies = parseCookies();
    const events = {
      ...Amplitude.commonEvents,
      ...properties,
      country_code: cookies?.countryCode ?? "",
      website_version: cookies?.signupVersion ?? "",
    };

    Amplitude.instance.logEvent(type, events);
  }
}

export const setUserProperties = (userId:string, properties: Record<string, any> | null = null) => {
  if (isBrowser()) {
    // eslint-disable-next-line global-require
    const amplitudeInstance = amplitudeJs.getInstance();
    if (userId) {
      const identifyObj = new amplitudeInstance.Identify();
      identifyObj.set('user_id', userId);
      if (properties !== null) {
        for (const key in properties) {
          if (Object.prototype.hasOwnProperty.call(properties, key)) {
            identifyObj.set(key, properties[key]);
          }
        }
      }
      amplitudeInstance.identify(identifyObj);
      amplitudeInstance.setUserId(userId);
    }
  }
};

export const amplitudeIncrementUserProperty = (
  propertyName: string,
  increment = 1
) => {
  const amplitudeInstance = amplitudeJs.getInstance();
  if (AMPLITUDE_KEY) {
    amplitudeInstance.init(AMPLITUDE_KEY);
    const identity = new amplitudeInstance.Identify().add(
      propertyName,
      increment
    );
    amplitudeInstance.identify(identity);
  }
};

export type userPropertiesType = {
  propertyName: string;
  value: any;
};

export const amplitudeSendUserProperty = (
  userProperties: userPropertiesType[],
  userID?: string
) => {
  const amplitudeInstance = amplitudeJs.getInstance();
  if (AMPLITUDE_KEY) {
    amplitudeInstance.init(AMPLITUDE_KEY);
    const userPropertiesObj: { [key: string]: any } = {};
    userProperties.map((userProperty: userPropertiesType) => {
      userPropertiesObj[userProperty.propertyName] = userProperty.value;
    });

    if (userID) amplitudeInstance.setUserId(userID);
    amplitudeInstance.setUserProperties(userPropertiesObj);
  }
};

export const clearAmplitude = () => {
  const amplitudeInstance = amplitudeJs.getInstance();
  if (AMPLITUDE_KEY) {
    amplitudeInstance.init(AMPLITUDE_KEY);
    amplitudeInstance.setUserId(null);
  }
  // amplitudeInstance.setDeviceId(sessionStorage.getItem('amplitudeDeviceId'));
};

export default Amplitude;
